export default __webpack_public_path__ + "static/media/OwlReader.7ffde27e.png";